module.exports = __webpack_public_path__ + "img/setarrow.0749bcc6.svg";